module.exports = __webpack_public_path__ + "static/media/bg_card_4_wap.25fda518.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/bg_card_4_wap.png
// module id = 618
// module chunks = 0